<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <h2>{{ isEdit ? 'Edit Staff' : 'Add Staff' }}</h2>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <form (ngSubmit)="onSubmit()" #form="ngForm">
    <div class="modal-body">

      <div class="grid">

        <!-- Name -->
        <div class="form-group">
          <input type="text" [(ngModel)]="staff.name" name="name" required placeholder=" " />
          <label>Name</label>
          <span class="error" *ngIf="fieldErrors['name']">{{fieldErrors['name']}}</span>
        </div>

        <!-- Email -->
        <div class="form-group">
          <input type="email" [(ngModel)]="staff.email" name="email" required placeholder=" " [readOnly]="isEdit" />
          <label>Email</label>
          <span class="error" *ngIf="fieldErrors['email']">{{fieldErrors['email']}}</span>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <input type="text" [(ngModel)]="staff.phone_number" name="phone_number" required placeholder=" " />
          <label>Phone Number</label>
          <span class="error" *ngIf="fieldErrors['phone_number']">{{fieldErrors['phone_number']}}</span>
        </div>

        <!-- Address -->
        <div class="form-group full">
          <input type="text" [(ngModel)]="staff.address" name="address" required placeholder=" " />
          <label>Address</label>
          <span class="error" *ngIf="fieldErrors['address']">{{fieldErrors['address']}}</span>
        </div>

        <!-- Pincode -->
        <div class="form-group pincode-wrap">
          <input type="text" [(ngModel)]="staff.pincode" name="pincode" (ngModelChange)="onPincodeChange($event)" required placeholder=" " maxlength="6" />
          <label>Pincode</label>
          <span class="pincode-status verifying" *ngIf="pincodeVerifying"><i class="fas fa-spinner fa-spin"></i></span>
          <span class="pincode-status verified" *ngIf="!pincodeVerifying && pinLocationVerified"><i class="fas fa-check-circle"></i></span>
          <span class="error" *ngIf="fieldErrors['pincode']">{{fieldErrors['pincode']}}</span>
        </div>

        <!-- City -->
        <div class="form-group">
          <input type="text" [(ngModel)]="staff.city" name="city" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>City</label>
          <span class="error" *ngIf="fieldErrors['city']">{{fieldErrors['city']}}</span>
        </div>

        <!-- State -->
        <div class="form-group">
          <input type="text" [(ngModel)]="staff.state" name="state" [readOnly]="pinLocationVerified" required placeholder=" " />
          <label>State</label>
          <span class="error" *ngIf="fieldErrors['state']">{{fieldErrors['state']}}</span>
        </div>

      </div>

      <div *ngIf="errorMsg" class="error-msg">{{errorMsg}}</div>

    </div>

    <div class="modal-footer">
      <button class="btn secondary" type="button" (click)="onClose()">Cancel</button>
      <button class="btn primary" type="submit" [disabled]="submitting">
        {{ submitting ? (isEdit ? 'Updating...' : 'Saving...') : (isEdit ? 'Update Staff' : 'Add Staff') }}
      </button>
    </div>
  </form>
</div>